import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  BooleanInput,
  BulkDeleteButton,
  CreateButton
} from 'react-admin';
import Toolbar from '@material-ui/core/Toolbar';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import DateInput from '../../../../components/DateInput';
import LinkToList from './LinkToList';
import aggrP from '../aggrP';
import resourceLocales from './locales';
import resourceConfig from './config';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import directionType from '../directionType';
import docStatus from '../docStatus';
import docStatusSystem from '../docStatusSystem';
import errorModel from '../errorModel';
import objectSendModel from '../objectSendModel';
import aggrDocType from '../aggrDocType';
import unitSerialNumberType from '../unitSerialNumberType';
import SendButton from './SendButton';
import documentImport from '../documentImport';
import exporter from '../../../../utils/exporter';
import docUpdate from '../docUpdate';
import docCheckStatus from '../docCheckStatus';
import PostPagination from '../../../../utils/pagination';
import ExportDocButton from '../docH/ExportDocButton';
const ResourceIcon = BookmarkIcon;

const listStyles = {};

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <docUpdate.Button {...props} bulk docType={'AGGR'} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'docnum'} />
    <TextInput source={'guid'} />
    <aggrDocType.Input source={'typedoc'} />
    <unitSerialNumberType.Input source={'unitSerialNumberType'} />
    <docCheckStatus.Input source={'checkStatus'} />
  </Filter>
);

const ChildrenPButton = (props) => {
  return (
    <aggrP.LinkToList
      label={`resources.${resourceConfig.name}.aggrP`}
      filter={{
        overEntityIds: props.record.id,
      }}
    />
  );
};

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <documentImport.OpenButton params={{ docType: 'AGGR' }} />
    <CreateButton basePath={basePath} to={`${basePath}/create`} />
    <ExportDocButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    actions={<ResourceActions />}
    bulkActionButtons={<ResourceBulkActionButtons />}
    exporter={exporter}
    pagination={<PostPagination />}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />
      <TextField source={'docnum'} />
      <aggrDocType.Field source={'typedoc'} />
      <unitSerialNumberType.Field source={'unitSerialNumberType'} />
      <docStatusSystem.Field source={'documentSystemStatus'} />
      <TextField source={'guid'} />
      <docCheckStatus.Field source={'checkStatus'} />
      <errorModel.LinkToRelatedList type={'AGGR'} />
      <objectSendModel.LinkToRelatedList type={'AGGR'} />
      <SendButton />
      <ChildrenPButton />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.name}
    &quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source={'actionId'} />
      {/* <TextInput source={'companyUniqName'} />
            <TextInput source={'creatorUsername'} /> */}
      <DateInput
        source={'dateCreate'}
        label={`resources.${resourceConfig.name}.fields.dateCreate`}
      />
      <DateInput source={'dateSend'} label={`resources.${resourceConfig.name}.fields.dateSend`} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      {/* <NumberInput source={'documentLinkId'} />
            <docLinkType.Input source={'documentLinkType'} /> */}
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <errorModel.Input source={'errorModelId'} />
      <TextInput source={'participantId'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'receiverId'} />
      <TextInput source={'reportId'} />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
      <aggrDocType.Input source={'typedoc'} />
      <unitSerialNumberType.Input source={'unitSerialNumberType'} />
      <TextInput source={'uitu'} />
      <BooleanInput source={'disaggregationCreated'} />
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} title={<ResourceTitle />} {...props}>
    <SimpleForm redirect={false}>
      <TextField source={'id'} />
      <TextInput source={'actionId'} />
      {/* <TextInput source={'companyUniqName'} />
            <TextInput source={'creatorUsername'} /> */}
      <DateInput
        source={'dateCreate'}
        label={`resources.${resourceConfig.name}.fields.dateCreate`}
      />
      <TextField source={'timeCreate'} />
      <DateInput source={'dateSend'} label={`resources.${resourceConfig.name}.fields.dateSend`} />
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      {/* <NumberInput source={'documentLinkId'} />
            <docLinkType.Input source={'documentLinkType'} /> */}
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <errorModel.Input source={'errorModelId'} />
      <TextInput source={'participantId'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'receiverId'} />
      <TextInput source={'reportId'} />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
      <aggrDocType.Input source={'typedoc'} />
      <unitSerialNumberType.Input source={'unitSerialNumberType'} />
      <TextInput source={'uitu'} />
      <TextInput source={'guid'} />
      <docCheckStatus.Input source={'checkStatus'} />
      <BooleanInput source={'disaggregationCreated'} />
    </SimpleForm>
  </Edit>
);

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      dateCreate: {
        type: 'dateTime',
      },
      dateSend: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
    },
    filters: {
      dateCreate: {
        type: 'dateTime',
      },
      dateSend: {
        type: 'dateTime',
      },
      processedDate: {
        type: 'dateTime',
      },
    },
  },
};
